import { debounce } from "@/utils/debounce";
import { useEffect, useState } from "react";

export const useScroll = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", debounce(handleScroll, 100));

    handleScroll();

    return () =>
      window.removeEventListener("scroll", debounce(handleScroll, 100));
  }, []);

  return scrollY;
};
